<template>
    <v-container>
        <div>
            <v-flex>
                <v-row>
                    <h1 class="page-title">Drivers</h1>
                    <v-spacer class="line"></v-spacer>
                    <hr>
                    <v-menu>
                        <template v-slot:activator="{ on }">
                          <span v-if="areas.length !== 0">
                            <v-btn
                                    tile
                                    small
                                    class="primary dropdown-menu-activator"
                                    depressed
                                    v-on="on"
                            ><v-icon left>mdi-plus</v-icon>Add Driver
                            </v-btn>
                          </span>
                          <span v-else>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn color="primary" dark v-on="on" aria-disabled="true">
                                        <v-icon left>mdi-plus</v-icon>Add Driver
                                    </v-btn>
                                </template>
                                <span>At first please add area</span>
                            </v-tooltip>
                          </span>
                        </template>
                        <v-list>
                            <new-driver-modal></new-driver-modal>
                            <new-driver-half-board-modal></new-driver-half-board-modal>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-flex>
            <v-row dense>
                <v-col cols="12" sm="4" md="4">
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                        v-model="filter_status"
                        :items="driver_status_list"
                        item-text="name"
                        item-value="id"
                        label="All statuses"
                        solo
                        clearable
                        hide-details
                        v-on:change="onStatusfilter"
                    >
                        <template
                            slot="selection"
                            slot-scope="data"
                        >
                            <div>
                                <div v-html="data.item.name" />
                            </div>
                        </template>
                        <template
                            slot="item"
                            slot-scope="data"
                        >
                            <!-- Root item (group) -->
                            <template v-if="data.item.type == 'root'">
                                <div class="select-drop-item-rootgroup">
                                <div v-html="data.item.name" />
                                </div>
                            </template>
                            <!-- sub item (sub group) -->
                            <template v-else>
                                <div class="select-drop-item-subgroup">
                                <div v-html="data.item.name" />
                                </div>
                            </template>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field
                        solo
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        v-model="filter_search"
                        label="Search Drivers"
                        clearable
                    ></v-text-field>
                </v-col>
            </v-row>

            <span v-if="driversSearchedPaged.length === 0" class="pl-2">No drivers found</span>
            <v-simple-table v-if="driversSearchedPaged.length !==0">
                <thead>
                <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Areas</th>
                    <th class="text-left">Data Full</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">Activation Date</th>
                    <th class="text-left">Activity</th>
                    <th class="text-left"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="person of driversSearchedPaged" :key="person.id">
                        <td class="person-name-td">
                            <span class="person-name">{{ person.first_name }} {{ person.last_name }}</span>

                        </td>
                        <td class="person-area-td">
                            <span class="person-area">{{ getArealabelById(person.area_ids) }}</span>
                        </td>
                        <td class="person-area-td">
                            <span :class="person.filledDataColor">{{ person.filledDataCount }}%</span>
                        </td>
                        <td>
                            <span v-if="person.status == DRIVER_STATUS_ACTIVE">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon :color="green" v-on="on">mdi-checkbox-blank-circle</v-icon>
                                    </template>
                                        <span>Activated, {{person.activated_at | activityTime}}</span>
                                </v-tooltip>
                            </span>
                            <span v-if="person.status == DRIVER_STATUS_INACTIVE">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <v-icon :color="orange" v-on="on">mdi-checkbox-blank-circle</v-icon>
                                    </template>
                                    <span>Inactive Driver</span>
                                </v-tooltip>
                            </span>
                            <span v-if="person.status == DRIVER_STATUS_REGISTRED">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                    <v-icon :color="indigo" v-on="on">mdi-checkbox-blank-circle</v-icon>
                                    </template>
                                        <span>Applicant Driver</span>
                                </v-tooltip>
                            </span>
                        </td>
                        <td>
                            <v-tooltip right v-if="person.status == DRIVER_STATUS_ACTIVE">
                                <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                        {{person.activated_at | registrationFinishTime}}
                                    </span>
                                </template>
                                    <span>Activated at</span>
                            </v-tooltip>
                        </td>
                        <td>
                            <span v-if="person.activity_status == ACTIVITY_STATUS_ONLINE">
                                <v-chip
                                    class="ma-2"
                                    color="green"
                                    text-color="white"
                                    x-small
                                >
                                    online
                                </v-chip>
                            </span>
                            <span v-if="person.activity_status == ACTIVITY_STATUS_DISCONNECTED">
                                was online: {{person.activity_time | activityTime}}
                            </span>
                            <v-tooltip v-if="person.push_token" right>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="blue" v-on="on">mdi-cloud-lock-outline</v-icon>
                                </template>
                                <span>Firebase token obtained</span>
                            </v-tooltip>
                        </td>
                        <td>
                            <v-btn-toggle class="float-right primary">
                            <view-driver-modal :thisDriverData="person"></view-driver-modal>
                                <template>
                                    <div class="text-center">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                        tile
                                                        small
                                                        class="primary dropdown-menu-activator"
                                                        depressed
                                                        v-on="on"
                                                        :loading="localLoading"
                                                        ref="optionsMenu"
                                                >options<v-icon>mdi-menu-down</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-title v-if="person.status == DRIVER_STATUS_ACTIVE" class="pointer"
                                                                       @click="inactiveItem(DRIVER_STATUS_INACTIVE, person.id)">Mark as Inactive</v-list-item-title>
                                                    <v-list-item-title v-else class="pointer"
                                                                       @click="inactiveItem(DRIVER_STATUS_ACTIVE, person.id)">Mark as Active</v-list-item-title>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title v-if="person.not_progressing == PROGRESSING_PROCESSING" class="pointer"
                                                                       @click="notProgressingItem(PROGRESSING_NOT_PROGRESSING, person.id)">Mark as Not Progressing</v-list-item-title>
                                                    <v-list-item-title v-else class="pointer"
                                                                       @click="notProgressingItem(PROGRESSING_PROCESSING, person.id)">Restore Progressing</v-list-item-title>
                                                </v-list-item>
                                                    <edit-driver-modal :thisDriverData="person" @driverUpdated="editedDriver">
                                                        <v-list-item ref="editDriverItem" class="pointer">
                                                            <v-list-item-title>Edit Driver</v-list-item-title>
                                                        </v-list-item>
                                                    </edit-driver-modal>
                                                    <edit-working-time-modal :thisDriverData="person" @driverUpdated="editedDriver"></edit-working-time-modal>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </template>
                            </v-btn-toggle>
                        </td>
                </tr>
                </tbody>
            </v-simple-table>
            <v-row>
                <v-col cols="12" sm="2" md="2">
                    <v-flex class="d-flex flex-row">
                        <div style="min-width:75px" class="pt-2">
                            Per page:
                        </div>
                        <v-select
                            :items="per_page_list"
                            label="Solo field"
                            solo
                            dense
                            v-model="per_page"
                            v-on:change="onCangePerPage"
                            hide-details=""
                        ></v-select>
                    </v-flex>
                </v-col>
                <v-col cols="12" sm="8" md="8">
                <v-pagination
                    :value="page"
                    :length="total_pages"
                    :total-visible="10"
                    @input="onChangePage"
                ></v-pagination>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    {{((page - 1) * per_page) + 1}}&nbsp;-&nbsp;{{ ((page * per_page) < driversSearched.length) ? (page * per_page) : driversSearched.length }}&nbsp;of&nbsp;{{driversSearched.length}}
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex'
    import * as _ from 'lodash'
    import moment from 'moment'
    import EditWorkingTimeModal from './EditWorkingTimeModal'

    const DRIVER_STATUS_ACTIVE = 10;
    const DRIVER_STATUS_INACTIVE = 20;
    const DRIVER_STATUS_REGISTRED = 30;

    // const DRIVER_STATUS_ALL = 110;
    const DRIVER_STATUS_COMPLETED = 120;
    const DRIVER_STATUS_INCOMPLETE = 130;
    const DRIVER_STATUS_NOT_PROGRESSING = 140;
    const DRIVER_STATUS_NOT_MENAGED = 150;

    const PROGRESSING_NOT_PROGRESSING = 10;
    const PROGRESSING_PROCESSING = 20;

    const ACTIVITY_STATUS_ONLINE = 10;
    const ACTIVITY_STATUS_DISCONNECTED = 20;

    // const REGISTRATION_STEP_NEW = 10;
    // const REGISTRATION_STEP_AREAS = 20;
    // const REGISTRATION_STEP_INFO = 30;
    const REGISTRATION_STEP_FINISH = 40;

    export default {
        name: "ListDriverName",
        components: {
            'edit-working-time-modal': EditWorkingTimeModal
        },
        data: () => ({
            green:"#0ab90a",
            orange:"#dc7319d1",
            indigo:"#3F51B5",
            DRIVER_STATUS_ACTIVE: DRIVER_STATUS_ACTIVE,
            DRIVER_STATUS_INACTIVE: DRIVER_STATUS_INACTIVE,
            DRIVER_STATUS_REGISTRED: DRIVER_STATUS_REGISTRED,
            ACTIVITY_STATUS_ONLINE: ACTIVITY_STATUS_ONLINE,
            ACTIVITY_STATUS_DISCONNECTED: ACTIVITY_STATUS_DISCONNECTED,
            PROGRESSING_NOT_PROGRESSING: PROGRESSING_NOT_PROGRESSING,
            PROGRESSING_PROCESSING: PROGRESSING_PROCESSING,
            localLoading: false,
            REGISTRATION_STEP_FINISH: REGISTRATION_STEP_FINISH,
            // --
            filter_search: void 0,
            filter_status: DRIVER_STATUS_ACTIVE, // default active only
            driver_status_list: [
                // { id: 0, type: 'root', name: 'Show all'},
                { id: DRIVER_STATUS_REGISTRED, type: 'root', name: 'All' },
                { id: DRIVER_STATUS_COMPLETED, type: 'subgroup', name: 'Completed'}, // sub
                { id: DRIVER_STATUS_INCOMPLETE, type: 'subgroup', name: 'Incomplete'}, // sub
                { id: DRIVER_STATUS_NOT_PROGRESSING, type: 'subgroup', name: 'Not Progressing'}, // sub
                { id: DRIVER_STATUS_NOT_MENAGED, type: 'subgroup', name: 'Progressing'}, // sub
                { id: DRIVER_STATUS_ACTIVE, type: 'root', name: 'Show only active' },
                { id: DRIVER_STATUS_INACTIVE, type: 'root', name: 'Show only inactive' },
            ],
            page: 1,
            per_page: 15,
            per_page_list: [10, 15, 50, 100, 1000],
        }),
        mounted(){
            Promise.all([
                this.$store.dispatch('fetchAreas'),
                this.$store.dispatch('fetchDrivers'),
                this.$store.dispatch('fetchRestaurants') // fetch data for modal
            ]).then(() => {
                // open driver from URL
                if (_.get(this.$router.currentRoute, 'matched[0].path') == "/drivers/:first_name") {
                    let driver = _.find(this.drivers, p => p.id == _.get(this.$router.currentRoute, 'params.first_name'));
                    if (driver) {
                        this.filter_search = driver.email;
                        this.filter_status = void 0; // show all

                        // auto open edit driver dialog
                        this.$nextTick(() => {
                            this.$refs['optionsMenu'][0].$el.click();
                            this.$nextTick(() => {
                                this.$refs['editDriverItem'][0].$el.click();
                            });
                        });
                    }
                    this.$router.replace("/drivers"); // change URL
                }
            })
        },
        created()
        {
            // --
        },
        computed: {
            ...mapGetters({
                drivers: 'allDrivers',
                areas: 'areas',
            }),
            driversSearched() {
                let result = this.drivers;

                result = _.map(result, p => {
                    p.filledDataCount = this.getFilledDataCount(p); // resentage

                    // color:
                    if (p.filledDataCount >= 95 ) p.filledDataColor = 'green--text';
                    else if (p.filledDataCount >= 80 ) p.filledDataColor = 'blue-grey--text';
                    else if (p.filledDataCount >= 50 ) p.filledDataColor = 'blue--text';
                    else if (p.filledDataCount >= 40 ) p.filledDataColor = 'deep-orange--text';
                    else if (p.filledDataCount >= 30 ) p.filledDataColor = 'red--text darken-4';
                    else p.filledDataColor = 'pink--text darken-4';

                    return p;
                });

                if (this.filter_search) {
                    result = _.filter(result, p => p.full_name.toLowerCase().indexOf(this.filter_search) !== -1 || p.email.toLowerCase().indexOf(this.filter_search) !== -1);
                }

                // filter data full progress
                switch (this.filter_status) {
                    case DRIVER_STATUS_REGISTRED:
                    case DRIVER_STATUS_ACTIVE:
                    case DRIVER_STATUS_INACTIVE:
                        result = _.filter(result, p => p.status == this.filter_status);
                    break;
                    case DRIVER_STATUS_COMPLETED:
                        result = _.filter(result, p => p.status == DRIVER_STATUS_REGISTRED);
                        result = _.filter(result, p => p.filledDataCount >= 70);
                    break;
                    case DRIVER_STATUS_INCOMPLETE:
                        result = _.filter(result, p => p.status == DRIVER_STATUS_REGISTRED);
                        result = _.filter(result, p => p.filledDataCount < 70);
                    break;
                    case DRIVER_STATUS_NOT_PROGRESSING:
                        result = _.filter(result, p => p.status == DRIVER_STATUS_REGISTRED);
                        result = _.filter(result, p => p.not_progressing == PROGRESSING_NOT_PROGRESSING);
                    break;
                    case DRIVER_STATUS_NOT_MENAGED:
                        result = _.filter(result, p => p.status == DRIVER_STATUS_REGISTRED);
                        result = _.filter(result, p => p.not_progressing == PROGRESSING_PROCESSING);
                    break;
                    default:
                        // show all
                }
                
                return result;
            },
            driverList() {
                return this.drivers;
            },
            driversSearchedPaged() {
                let start = this.per_page * (this.page - 1);
                let end = start + this.per_page;
                return this.driversSearched.slice(start, end);
            },
            total_pages() {
                return Math.ceil(this.driversSearched.length / this.per_page);
            },
        },
        methods: {
            inactiveItem(status, driver_id) {
                this.localLoading = true
                this.$store.dispatch('setDriverStatus', {status, driver_id}).then(() => {
                }).finally(() => {
                    this.localLoading = false;
                });
            },
            notProgressingItem(not_progressing, driver_id) {
                this.localLoading = true
                this.$store.dispatch('setDriverProgressing', {not_progressing, driver_id}).then(() => {
                }).finally(() => {
                    this.localLoading = false;
                });
            },
            editedDriver(/*payload*/) {
                //
            },
            getArealabelById(area_ids) {
                if (!area_ids || area_ids.length == 0) {
                    return '-';
                }

                let result = [];
                for (let i = 0; i < area_ids.length; i++) {
                    let item = _.find(this.areas, p => +p.id == +area_ids[i].area_id);
                    if (item) {
                        result.push(item.name);
                    }
                }

                return result.join(', ');
            },
            onChangePage(page) {
                this.page = page;
            },
            getFilledDataCount(driver) {
                let fields_to_test = [
                    'first_name',
                    'last_name',
                    'email',
                    'address_1',
                    'address_2',
                    'postcode',
                    'city',
                    'phone',
                    'date_of_birth',
                    'emergency_contact_name',
                    'emergency_contact_phone',
                    'car_make',
                    'car_model',
                    'car_registration',
                    'car_insurance_renewal_date',
                    'car_insurer',
                    // 'have_experience',
                    // 'experience_description',
                    'bank_name_of_account_holder',
                    'bank_sort_code',
                    'bank_account_number',
                    'driver_license_front_photo',
                    'driver_license_back_photo',
                    'identity_photo',
                    'right_to_work_photos',
                    'area_ids',
                    // 'default_working_time',
                ];

                let filled_count = _.reduce(fields_to_test, (sum, name) => {
                    if (_.isEmpty(driver[name])) {
                        return sum;
                    }
                    return sum + 1;
                }, 0);

                return ((filled_count / fields_to_test.length) * 100).toFixed(0);
            },
            onCangePerPage() {
                this.page = 1;
            },
            onStatusfilter() {
                this.page = 1;
            }
        },
        filters: {
            activityTime: function (date) {
                if (!date) {
                    return 'never';
                }

                return moment.utc(date, 'YYYY-MM-DD HH:mm:ss').local().fromNow();
            },
            registrationFinishTime: function (date) {
                if (!date) {
                    return '-';
                }

                return moment.utc(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
            },
        },
    }
</script>

<style scoped>
  .select-drop-item-rootgroup {
    background: #e0e0e0;
  }

  .select-drop-item-subgroup {
    padding-left: 16px;
  }
</style>